import Vue from 'vue'
import VueRouter from 'vue-router'
import {
    routers
} from './router'

Vue.use(VueRouter)

// 路由配置
const RouterConfig = {
    // mode: 'history',
    routes: routers
}

export const router = new VueRouter(RouterConfig)

router.beforeEach((to, from, next) => {
    if (to.meta && to.meta.title) {
        window.document.title = to.meta.title
    }
    next()
})

router.afterEach((to, from, next) => {
    window.scrollTo(0, 0)
})



// WEBPACK FOOTER //
// ./src/router/index.js